module.exports = __webpack_public_path__ + "static/media/trend.ae16835e.jpg";